"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDOMElement = void 0;
var isDOMElement = function (target) {
    if (!target)
        return false;
    return target instanceof Node && target.nodeType === 1;
};
exports.isDOMElement = isDOMElement;
